import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../features/auth/auth.service';
import {
  AUTHENTICATION_REQUEST_INTENT,
  AUTHENTICATION_REQUIRED,
} from './authentication-required.context';

export const authenticationRequiredInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 &&
          request.context.get(AUTHENTICATION_REQUIRED)) {
        authService.handleExpiredSession(request.context.get(AUTHENTICATION_REQUEST_INTENT));
      }

      return throwError(() => error);
    })
  );
};
